import {AppUserInterface} from "../AppUserInterface/AppUserInterface";
import {loadSearchTableHtmlAsPromise} from "./loadSearchTableHtmlAsPromise";

export function runSearch(
    userInterface: AppUserInterface,
    server:        string,
    regionId:      string,
    locale:        string,
    pageSeoString: string
): void {
    if (userInterface.isSearchRunning || userInterface.searchBox.value.length === 0) {
        return;
    }

    userInterface.isSearchRunning = true;

    userInterface.searchBox.disabled                = true;
    userInterface.magnifyingGlassIcon.style.display = 'none';
    userInterface.spinnerIcon.style.display         = 'block';

    const searchQuery = userInterface.searchBox.value.trim();
    const promiseOfSearchedTableHtml = loadSearchTableHtmlAsPromise(searchQuery, server, regionId, locale, pageSeoString);

    promiseOfSearchedTableHtml
        .then(response => response.json())
        .then(tableHtml => {
            userInterface.hideMainSnowTable();

            userInterface.epSnowContainer.insertAdjacentHTML('beforeend', tableHtml);

            (document.querySelector('#btn-na-puvodni') as HTMLSpanElement)
                .addEventListener('click', () => {
                    userInterface.searchBox.disabled                = false;
                    userInterface.searchBox.value                   = '';
                    userInterface.magnifyingGlassIcon.style.display = 'block';
                    userInterface.spinnerIcon.style.display         = 'none';

                    userInterface.showMainSnowTable();
                    (document.querySelector('#tabsnihfiltr') as HTMLTableElement).remove();

                    userInterface.isSearchRunning = false;
                });
        })
        .catch(() => {
            console.log('Searching failed.');
            userInterface.isSearchRunning = false;
        });
}